import React from 'react'
import Link from 'next/link'

import { Tab, TabList, Tabs } from '@wartek-id/tabs'

import { DesktopPageHeader, PageContainer } from 'components/ResponsiveLayout'
import { PELATIHAN_MANDIRI_HELPDESK_LINK } from 'app/PelatihanMandiriPage/constants'
import {
  getWebinarTabLabel,
  useWebinarTabCount,
} from 'app/PelatihanMandiriPage/hooks/useWebinarTabCount'

type DesktopLandingShellProps = {
  activeMenu: 'untuk-anda' | 'topik' | 'aksi-nyata' | 'webinar'
  children: React.ReactNode
}

const PAGE_TITLE = 'Pelatihan Mandiri'

const getNavItems = (webinarCount?: number) =>
  [
    {
      name: 'topik',
      label: 'Topik',
      href: '/pelatihan-mandiri/daftar-topik',
    },
    {
      name: 'aksi-nyata',
      label: 'Aksi Nyata',
      href: '/pelatihan-mandiri/daftar-aksi-nyata',
    },
    {
      name: 'webinar',
      label: getWebinarTabLabel(webinarCount),
      href: '/pelatihan-mandiri/webinar',
    },
  ] as const

const DesktopLandingShell = ({
  activeMenu,
  children,
}: DesktopLandingShellProps) => {
  const webinarCount = useWebinarTabCount()
  const navItems = getNavItems(webinarCount)

  return (
    <div className="min-h-screen bg-gray-10">
      <DesktopPageHeader
        navLinks={[
          {
            label: 'Bantuan',
            href: PELATIHAN_MANDIRI_HELPDESK_LINK,
            external: true,
          },
        ]}
        breadcrumbItems={[{ label: PAGE_TITLE, href: null }]}
        bottomBar={
          <div className="border-b border-gray-20 bg-white">
            <PageContainer className="!py-0">
              <Tabs
                withBorder
                selectedIndex={navItems.findIndex(
                  (item) => item.name === activeMenu
                )}
                onChange={(index) => {
                  window.location.href = navItems[index].href
                }}
              >
                <TabList
                  style={{
                    borderBottom: '1px solid var(--color-border-subdued)',
                  }}
                >
                  {navItems.map((item) => (
                    <Tab key={item.name}>
                      <Link
                        href={item.href}
                        className="flex w-full items-center justify-center"
                        data-testid={item.name}
                      >
                        {item.label}
                      </Link>
                    </Tab>
                  ))}
                </TabList>
              </Tabs>
            </PageContainer>
          </div>
        }
      />
      <PageContainer className="pt-6">{children}</PageContainer>
    </div>
  )
}

export default DesktopLandingShell
